import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getOr } from 'lodash/fp';
import giftCards from './api';

const name = 'giftCards';

const redeem = createAsyncThunk('giftCards/redeem', async (payload) => {
  const { cardNumber, data } = payload;
  const response = await giftCards.redeem(cardNumber, { data });

  return response;
});

const gcRedeem = createAsyncThunk(
  'giftCards/gcRedeem',
  async (data, { rejectWithValue }) => {
    try {
      return await giftCards.gcRedeem({ data });
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

const balance = createAsyncThunk('giftCards/balance', async (cardNumber) => {
  const fn = giftCards.balance(cardNumber);
  const response = await fn();
  return response;
});

const giftCardsList = createAsyncThunk(
  'giftCards/giftCardsList',
  async (cardNumber) => {
    return giftCards.giftCardsList(cardNumber);
  }
);

const { actions, reducer } = {
  ...createSlice({
    name,
    initialState: {
      isLoading: false,
      error: false,
      details: {},
      requestOtp: false,
      otp: false,
      list: {
        total: 0,
        data: [],
      },
    },
    reducers: {
      setFormData: (state, { payload }) => {
        state.formData = { ...state.formData, ...payload };
      },
      resetFormData: (state) => {
        state.formData = {};
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(redeem.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(redeem.fulfilled, (state, action) => {
          state.isLoading = false;
          state.details = action.payload;
        })
        .addCase(redeem.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })
        .addCase(gcRedeem.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(gcRedeem.fulfilled, (state, action) => {
          state.isLoading = false;
          state.details = action.payload.giftCard;
          state.otp = action.payload.otp ? true : state.otp;
        })
        .addCase(gcRedeem.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })
        .addCase(balance.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(balance.fulfilled, (state, action) => {
          state.isLoading = false;
          state.details = action.payload.orderNumber;
        })
        .addCase(balance.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        })
        .addCase(giftCardsList.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(giftCardsList.fulfilled, (state, action) => {
          state.isLoading = false;
          state.list = action.payload;
        })
        .addCase(giftCardsList.rejected, (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        });
    },
  }),
};

const selectors = {
  selectIsLoading: (state) => getOr('', 'isLoading', state[name]),
  selectGiftCards: (state) => getOr('', 'list', state[name]),
  selectDetails: (state) => getOr('', 'details', state[name]),
  selectOtp: (state) => getOr('', 'otp', state[name]),
};

export default {
  actions: {
    ...actions,
    redeem,
    balance,
    gcRedeem,
    giftCardsList,
  },
  selectors,
  reducer,
  name,
};
